// extracted by mini-css-extract-plugin
module.exports = {"desc":"style__desc__MFfu+"};